import { ProductAddonDetailPage } from '@/features/product-addon/pages/ProductAddonDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-addon/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_addon.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAddonDetailPage,
})
